<template>
	<div id="sampleTable">
		<div>
			<el-row :gutter="20">
				<el-col :span="2" class="yb">样本</el-col>
				<el-col :span="4"><el-input placeholder="搜索样本编号" v-model="projectStatus.sCode" suffix-icon="icon dficonfont icon-search"></el-input></el-col>
				<el-col :span="4">
					<el-select placeholder="请选择" v-model="projectStatus.SsId">
						<el-option v-for="(item, index) in statusData" :key="index" :label="item.Ss_Id_Name" :value="item.Ss_Id"></el-option>
					</el-select>
				</el-col>
				<el-col :span="3"><el-button type="primary" @click="search">查询</el-button></el-col>
				<el-col :span="3"><el-button type="primary" @click="reset">重置</el-button></el-col>
			</el-row>
		</div>
		<!-- 表格 -->
		<el-table class="sampleTable_table" ref="multipleTable" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
			<el-table-column prop="S_Code" label="样本编号"></el-table-column>
			<el-table-column prop="Ss_Id_Name" label="状态"></el-table-column>
			<el-table-column prop="Pi_Ext" label="电话区号"></el-table-column>
			<el-table-column prop="S_Tel" label="电话号码"></el-table-column>
			<el-table-column prop="name" label="电话分机"></el-table-column>
			<!-- <el-table-column prop="address" label="省、市"></el-table-column>
			<el-table-column prop="address" label="地区"></el-table-column> -->
		</el-table>
		<!-- 分页 -->
		<el-pagination
			class="sampleTable_laterPagin"
			@current-change="handleCurrentChange"
			:current-page="ipaging.currentPage"
			:page-size="ipaging.pageSize"
			layout="total, prev, pager, next, jumper"
			:total="ipaging.total"
		></el-pagination>
	</div>
</template>

<script>
export default {
	data() {
		return {
			statusData: [],
			tableData: [],
			ipaging: {
				total: 0,
				pageSize: 10,
				currentPage: 1
			},
			projectId: '', //项目id
			projectStatus: {
				sCode: '', //
				SsId: ''
			}
		};
	},
	computed: {
		prCode() {
			return this.$store.state.pr_Code;
		}
	},
	watch: {
		prCode(newId, oldId) {
			if (newId) {
				this.projectId = newId;
				this.loadData();
				this.getstatus();
			}
		}
	},
	mounted() {
		this.projectId = this.$store.state.pr_Code;
		this.loadData();
		this.getstatus();
	},
	methods: {
		reset() {
			this.projectStatus = {
				sCode: '',
				SsId: ''
			};
			this.loadData();
		},
		search() {
			this.loadData();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.ipaging.currentPage = val;
			this.loadData();
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		inquire() {
			let paramsData = {
				prCode: this.projectId,
				pageIndex: this.ipaging.currentPage,
				pageSize: this.ipaging.pageSize,
				sCode: this.projectStatus.sCode,
				SsId: this.projectStatus.SsId
			};
			return paramsData;
		},
		loadData() {
			if (this.projectId == '' || this.projectId == null) {
				// this.$message.error('请先选择项目');
				return false;
			}
			let data = this.inquire();
			let that = this;
			let params = {
				that: this,
				method: 'post',
				url: `${this.$config.service.querySampleDtoListList}`,
				data: data,
				cb(res) {
					if (res.result == '111111111111') {
						that.tableData = res.data;
						that.ipaging.total = res.total;
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},
		getstatus() {
			if (this.projectId == '' || this.projectId == null) {
				return false;
			}
			let that = this;
			let params = {
				that: this,
				method: 'post',
				url: `${this.$config.service.querySampleDtoSsIDList}`,
				data: {
					prCode: this.projectId
				},
				cb(res) {
					if (res.result == '111111111111') {
						that.statusData = res.data;
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style scoped="scoped" lang="scss">
#sampleTable {
	width: 100%;
	height: 100%;
	.yb {
		margin-left: 10px;
	}
	.sampleTable_laterPagin {
		margin-top: 77px;
		text-align: right;
	}
}
</style>
